export default __webpack_public_path__ + "static/media/LO14.a0800d9c.mp3";